import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=44abce88&"
import script from "./SideBar.vue?vue&type=script&lang=js&"
export * from "./SideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44abce88')) {
      api.createRecord('44abce88', component.options)
    } else {
      api.reload('44abce88', component.options)
    }
    module.hot.accept("./SideBar.vue?vue&type=template&id=44abce88&", function () {
      api.rerender('44abce88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SidebarPlugin/SideBar.vue"
export default component.exports